<div class="flex flex-col h-full">
  <div class="flex flex-row p-4 pr-6 border-b border-gray-1">
    <div class="h-8 flex flex-1 flex-wrap content-center font-semibold">
      {{ translations.title.text }}
    </div>
    <button
      id="options-panel-download-status-close"
      class="text-gray-8"
      modus-icon-button
      [modus-tooltip]="translations.close.tooltip.text"
      (click)="close()"
    >
      <md-icon>close</md-icon>
    </button>
  </div>

  <div class="flex-1 overflow-y-scroll p-4 text-sm">
    @if (hasDownloads()) {
      <div class="h-7 flex flex-row items-center pb-1">
        <div class="w-full text-sm font-bold">{{ translations.overallProgress.label.text }}</div>
        <!-- overall progress -->
        <sd-download-progress
          class="min-w-[26px] max-w-[26px] ml-2 flex justify-center"
          data-cy="download-overall-progress"
          [progress]="overallProgress()"
          [progressTooltip]="overallProgressTooltip()"
        ></sd-download-progress>
      </div>

      @for (scan of scanDownloadViews(); track $index) {
        <div>
          <!-- list scandata model -->
          <div class="flex flex-row items-center">
            <button modus-icon-button (click)="toggleExpanded(scan)">
              @if (scan.expanded) {
                <md-icon class="text-lg/5">caret_down</md-icon>
              } @else {
                <md-icon class="text-lg/5">caret_right</md-icon>
              }
            </button>
            <div
              class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-8 ml-1"
              [modus-tooltip]="scan.scandataModel.name"
            >
              {{ scan.scandataModel.name }}
            </div>
          </div>

          <!-- list scandata model files -->
          @if (scan.expanded) {
            <div class="pl-12 mb-2">
              @for (file of scan.files; track $index) {
                <div class="flex flex-row items-center">
                  <md-icon>{{ file.icon }}</md-icon>
                  <div
                    class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-8 ml-1"
                    [modus-tooltip]="file.scandataFile.name"
                  >
                    {{ file.scandataFile.name }}
                  </div>
                  <!-- progress -->
                  <sd-download-progress
                    class="min-w-[26px] max-w-[26px] flex justify-center ml-1"
                    data-cy="download-individual-progress"
                    [progress]="file.downloadProgress"
                    [progressTooltip]="file.downloadProgressTooltip"
                  ></sd-download-progress>
                </div>
              }
            </div>
          }
        </div>
      }
    } @else {
      <!-- no downloads -->
      {{ translations.noDownloads.text }}
    }
  </div>

  <!-- button group -->
  <div class="flex p-4 justify-end border-t border-gray-1">
    <button
      id="options-panel-download-clear"
      modus-button
      class="mr-4"
      color="secondary"
      [modus-tooltip]="translations.clear.tooltip.text"
      [disabled]="clearDisabled()"
      (click)="clearCompleted()"
    >
      {{ translations.clear.button.text }}
    </button>
    <button
      id="options-panel-download-cancel"
      modus-flat-button
      color="secondary"
      [modus-tooltip]="translations.cancel.tooltip.text"
      [disabled]="cancelDisabled()"
      (click)="cancelDownloads()"
    >
      {{ translations.cancel.button.text }}
    </button>
  </div>
</div>
